import { AwsUtil } from './../authentication/aws.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { AlertMessageService } from './alert-message/alert-message.service';

import { OnInit, Component, Input, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { AlertRow } from './alert-message/alert-row';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetFullTransactionRequest, WebApiEndpoints, GetFullTransactionResult } from '@liquitics/transaction';
import { Transaction } from '@liquitics/transaction';


@Component({
    selector: 'app-alert-table',
    templateUrl: './alert-table.component.html',
    styleUrls: ['./alert-table.component.css']
})
export class AlertTableComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input()
    displayedColumns;

    @Input()
    detailedTableMode = false;
    // tableData: AlertRow[];

    @Input()
    filterFunction: (rows: AlertRow[]) => AlertRow[];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    showTable = false;

    dataSource: MatTableDataSource<AlertRow>;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    fullTransaction: string;
    @ViewChild('popuptarget', { static: true }) popupTargetDiv;

    rowStream: BehaviorSubject<AlertRow[]>;
    subscription: Subscription;

    constructor(private alertMessageService: AlertMessageService, private awsUtil: AwsUtil) {
        this.rowStream = this.alertMessageService.getAlertRowSubject();
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.showTable = true;

        this.subscription = this.rowStream
            .subscribe({
                next: (rows: AlertRow[]) => {
                    if (this.filterFunction) {
                        rows = this.filterFunction(rows);
                    }
                    this.dataSource.data = rows;
                }
            });
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    alertClass(row: AlertRow): string {
        if (row.type === 'MISSING_PAYMENT') {
            return 'critical-alert';
        } else {
            return 'warning-alert';
        }
    }

    showTransaction(event: any, transaction: Transaction, overlayPanel: OverlayPanel) {
        const request = {
            currency: transaction.currency,
            eventDatetime: transaction.eventDatetime,
            flowKey: transaction.flowKey
        } as GetFullTransactionRequest;
        this.awsUtil.webAPICall(WebApiEndpoints.QueryFullTransaction, request)
            .then((result: GetFullTransactionResult) => {
                this.fullTransaction = JSON.stringify(result, null, 2);
                overlayPanel.toggle(event);
            })
    }
}



export class AlertMetricDataSource extends MatTableDataSource<any> {
    constructor(private alertStreamDisposable: BehaviorSubject<AlertRow[]>) {
        super();
    }
    connect(): BehaviorSubject<AlertRow[]> {
        return this.alertStreamDisposable;
    }

    disconnect() { }
}
